var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-info",on:{"click":_vm.refresh}},[_c('span',{staticClass:"fa fa-refresh"})])}
var staticRenderFns = []

export { render, staticRenderFns }